/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ModelDate
 */
export interface ModelDate  {
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof ModelDate
     */
    date_parts?: Array<Array<string>>;
    /**
     * 
     * @type {any}
     * @memberof ModelDate
     */
    season?: any | null;
    /**
     * 
     * @type {any}
     * @memberof ModelDate
     */
    circa?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ModelDate
     */
    literal?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelDate
     */
    raw?: string;
}

/**
 * Check if a given object implements the ModelDate interface.
 */
export function instanceOfModelDate(value: object): value is ModelDate {
    return true;
}

export function ModelDateFromJSON(json: any): ModelDate {
    return ModelDateFromJSONTyped(json, false);
}

export function ModelDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelDate {
    if (json == null) {
        return json;
    }
    return {
        
              'date_parts': json['date-parts'] == null ? undefined : json['date-parts'],
                  'season': json['season'] == null ? undefined : json['season'],
                  'circa': json['circa'] == null ? undefined : json['circa'],
                  'literal': json['literal'] == null ? undefined : json['literal'],
                  'raw': json['raw'] == null ? undefined : json['raw'],
    };
}

export function ModelDateToJSON(json: any): ModelDate {
    return ModelDateToJSONTyped(json, false);
}

export function ModelDateToJSONTyped(value?: ModelDate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'date-parts': value['date_parts'] == null? value['date_parts']: value['date_parts'],
        'season': value['season'],
        'circa': value['circa'],
        'literal': value['literal'],
        'raw': value['raw'],
    };
}


